import React from "react";
import { Box } from "@mui/material";
import {
  PlanTypesWrapper,
  PlanTypesContainer,
  PlanTypesTitle,
  PlanTypesSubtitle,
  PlanTypeCard,
  PlanIcon,
  PlanTitle,
  PlanDescription,
  PlanLink,
  PlanInfoIcon,
  PlanHeader,
  PlanHeaderContainer,
  PlanDescriptionContainer,
} from "../styles/components";

const PlanTypesSection: React.FC = () => {
  const planTypes = [
    {
      icon: "/images/landingpagev2/icons/green-energy.svg",
      title: "Green Energy",
      description:
        "A 100% GREEN fixed rate energy plan, supplied from a combination of wind and/or solar generation sources.",
      link: "Green plans →",
    },
    {
      icon: "/images/landingpagev2/icons/protected-ac.svg",
      title: "AC Protection",
      description:
        "Fixed rate energy and AC protection into one great plan.",
      link: "AC protection plans →",
    },
    {
      icon: "/images/landingpagev2/icons/wallet-pulse.svg",
      title: "Bill Credit",
      description:
        "Alongside a great fixed rate energy plan, our Usage Bill Credit plans offer up to $600 in annual bill credits.",
      link: "Bill credit plans →",
    },
  ];

  return (
    <PlanTypesWrapper>
      <PlanTypesContainer>
        <PlanTypesTitle variant="h2">
          Explore our plan types
          <br />
          <PlanTypesSubtitle variant="body1">
            <PlanInfoIcon
              src="/images/landingpagev2/icons/info-circle.svg"
              alt="Information icon"
            />{" "}
            Plan availability varies by location.
          </PlanTypesSubtitle>
        </PlanTypesTitle>

        <Box sx={{ width: "100%" }}>
          {planTypes.map((plan, index) => (
            <PlanTypeCard key={index}>
              <PlanHeaderContainer>
                <PlanHeader sx={{ alignItems:"self-end"}}>
                  <PlanIcon src={plan.icon} alt={`${plan.title} icon`} />
                  <PlanTitle variant="h3">{plan.title}</PlanTitle>
                </PlanHeader>
              </PlanHeaderContainer>
              <PlanDescriptionContainer>
                <PlanDescription variant="body1">
                  {plan.description}
                </PlanDescription>

                <PlanLink 
                  href="#plan-cards-section"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('plan-cards-section')?.scrollIntoView({ behavior: 'smooth', block: 'start', });
                  }}
                >
                  {plan.link}
                </PlanLink>
                {/* {index < planTypes.length - 1 && <PlanDivider />} */}
              </PlanDescriptionContainer>
            </PlanTypeCard>
          ))}
        </Box>
      </PlanTypesContainer>
    </PlanTypesWrapper>
  );
};

export default PlanTypesSection;
